module.exports = __webpack_public_path__ + "img/17-14-22.183a1dc7.jpg";